import classes from "./transparentButton.module.scss";

interface Props {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const TransparentButton = ({ label, onClick, disabled, className }: Props) => {
  return (
    <button
      className={`${classes.button} ${className}`}
      onClick={onClick}
      disabled={!!disabled}
    >
      {label}
    </button>
  );
};

export default TransparentButton;
